import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import clsx from 'clsx';
import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useBreadcrumbsStyles } from './Breadcrumbs.styles';

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  margin?: 'xs' | 'sm' | 'md';
  className?: string;
};

const Breadcrumbs = ({ items, margin = 'sm', className }: BreadcrumbsProps) => {
  const classes = useBreadcrumbsStyles();
  const history = useHistory();

  const marginClass =
    margin === 'md'
      ? classes.breadcrumbsMarginMd
      : margin === 'xs'
      ? classes.breadcrumbsMarginXs
      : classes.breadcrumbsMarginSm;

  const lastItem = items[items.length - 1];
  const lastItemKey = lastItem ? lastItem.href || lastItem.label : '';

  return (
    <nav className={clsx(classes.breadcrumbs, marginClass, className)} aria-label="Fil d'Ariane">
      {items.map(item => {
        const itemKey = item.href || item.label;
        const isLast = itemKey === lastItemKey;

        return (
          <Fragment key={itemKey}>
            {item.href && !isLast ? (
              <button
                type="button"
                className={classes.breadcrumbLink}
                onClick={() => history.push(item.href!)}>
                {item.label}
              </button>
            ) : (
              <span className={classes.breadcrumbCurrent}>{item.label}</span>
            )}
            {!isLast && <KeyboardArrowRightIcon className={classes.breadcrumbIcon} />}
          </Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
